// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"390":"swiper","407":"SimpleLightbox","645":"scroll-lock"}[chunkId] + ".js?v=" + {"390":"da8069f443c9a302cb19","407":"d5b4f17ba292ea803f38","645":"8993537234782f4030cb"}[chunkId] + "";
};